import styled from 'styled-components';
import Theme from '@adsk/alloy-react-theme';
import '@profile-ui/react-phone-input-2/lib/plain.css';

const PhoneInputStyled = styled.div`
  .react-tel-input--error {
    border: 1px solid ${Theme.colors.red500} !important;
    border-radius: 2px;
  }

  .react-tel-input {
    ${{ ...Theme.typography.labelMedium }};
    box-shadow: none;

    .form-control {
      border: 1px solid ${Theme.colors.charcoal400};
      border-radius: 2px;
      box-shadow: none;
      padding-left: calc(min(18vw, 95px));
      width: 100%;

      &:focus {
        border: 1px solid ${Theme.colors.adskBlue500} !important;
        box-shadow: 0 0 0 2px ${Theme.colors.focusHalo} !important;
      }

      &:hover {
        box-shadow: 0 0 0 2px ${Theme.colors.hoverHalo};
      }

      &:disabled {
        background-color: ${Theme.colors.charcoal050};
        border-color: ${Theme.colors.charcoal200};

        &:hover {
          box-shadow: none;
        }

        & + .flag-dropdown {
          background-color: ${Theme.colors.charcoal050};
          border-color: ${Theme.colors.charcoal200};
        }
      }
    }

    .flag-dropdown {
      border: 1px solid ${Theme.colors.charcoal400};
      box-shadow: none;
      min-width: 60px;
      width: 15%;

      @media (max-width: 576px) {
        min-width: 55px;
        width: 10%;
      }

      &:hover,
      &:visited {
        background-color: ${Theme.colors.white};
      }

      .selected-flag {
        padding-left: 10px;
        width: 100%;

        &:hover {
          background-color: ${Theme.colors.white};
        }

        .arrow {
          -webkit-transform: rotate(45deg);
          border: solid ${Theme.colors.charcoal700};
          border-width: 0 2px 2px 0;
          float: right;
          margin-top: -5px;
          padding: 3px;
          transform: rotate(45deg);
        }

        .arrow.up {
          -webkit-transform: rotate(-135deg);
          margin-top: -1px;
        }

        .flag {
          margin-right: 12px;
        }
      }
    }

    .country-list {
      ${{ ...Theme.typography.labelMedium }};
      box-shadow: ${Theme.shadows.highElevation};
      position: absolute;

      li {
        padding: 16px 16px 8px;

        .country-name {
          margin-left: 5px;
        }

        &[aria-selected='true'] {
          background-color: rgb(205, 234, 247, 0.35);
        }
      }

      li.search .search-box {
        padding: 3px 0;
      }
    }
  }
`;

PhoneInputStyled.displayName = 'PhoneInputStyled';

export default PhoneInputStyled;
